module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Noel Hynd\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Noel Hynd has sold more than four million copies of his books throughout the world, including "), _c('I', [_vm._v("The Enemy Within")]), _vm._v(" and "), _c('I', [_vm._v("Flowers From Berlin")]), _vm._v(".  His most recent novel, "), _c('I', [_vm._v("Hostage in Havana")]), _vm._v(", is the first book in the Cuban Trilogy starring Alexandria LaDuca.  Hynd lives in Culver City, California.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/vWENo6/tc-custom/9780310563105.jpg?1726340225119",
      "alt": "This image is the cover for the book Midnight in Madrid, The Russian Trilogy"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Midnight in Madrid, The Russian Trilogy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("When a mysterious relic is stolen from a Madrid museum, people are dying to discover its secrets. Literally. U.S. Treasury agent Alexandra LaDuca returns from Conspiracy in Kiev to track down the stolen artwork, a small carving called The Pietà of Malta. It seems to be a simple assignment, but nothing about this job is simple, as the mysteries and legends surrounding the relic become increasingly complex with claims of supernatural power. As aggressive, relentless, and stubborn as ever, Alex crisscrosses Europe through a web of intrigue, danger, and betrayal, joined by a polished, mysterious new partner. With echoes of classic detective and suspense fiction from The Maltese Falcon to The Da Vinci Code, Midnight in Madrid takes the reader on a nonstop spellbinding chase through a modern world of terrorists, art thieves, and cold-blooded killers.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Zondervan\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0